import { CustomComponentProps } from "utils/types/general.types";
import HashtagString from "../core/HashtagString";

export type PostTextProps = CustomComponentProps & {
    text: string;
};

const PostText = ({ text, className, style }: PostTextProps) => {
    return (
        <div className={`post-text ${className}`} style={style}>
            <HashtagString content={text} className="light-grey-text" />
            {/* <p>
                Yesterday with <a href="#">@Karen Miller</a> and{" "}
                <a href="#">@Marvin Stemperd</a> at the{" "}
                <a href="#">#Rock'n'Rolla</a> concert in LA. Was totally
                fantastic! People were really excited about this one!
            </p> */}
        </div>
    );
};

export default PostText;
